export enum StudentRoadmapTabStatus {
    EXPLORE = "EXPLORE",
    ROADMAP = 'ROADMAP',

}
export enum RoadmapProgressStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "DONE",
    SKIP = 'SKIP'
}